import { getCdbApiClient } from "../../../../api/cdbApi/cdbApi";
import type { Comparator, Filter, OrderBy } from "../../../../types/common";

import type { DataSource, BaseDataSourceConfiguration } from ".";

export interface InputTableFilter {
    column: string;
    requestParameterKey: string;
    comparator: Comparator;
}

export interface CdbInputTableSettings {
    tableName: string;
    filters: InputTableFilter[];
    orderBy: OrderBy[];
    columns: string[];
}

export interface CdbInputTableConfiguration
    extends BaseDataSourceConfiguration {
    type: DataSource.CDB_INPUT_TABLE;
    settings: CdbInputTableSettings;
    requirements: string[];
}

export const getCdbInputTableData = async (
    settings: CdbInputTableSettings,
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    inputPayload: any,
): Promise<Record<string, string>[] | undefined> => {
    const { tableName, filters, orderBy, columns } = settings;

    // convert input table filter to filter
    // TODO: add check to make sure requestparamter key exist
    const additionalFilters: Filter[] = filters.map((filter) => ({
        key: filter.column,
        value: inputPayload[filter.requestParameterKey],
        comparator: filter.comparator,
    }));

    const { data } = await (
        await getCdbApiClient()
    ).getDropdownValues({
        datasetName: tableName,
        columnNames: columns.join(","),
        additionalFilters,
        orderBy,
        pageToken: 0,
        pageSize: 50,
    });

    return data;
};
